import React, { useState, useEffect, useCallback } from 'react';
import styles from './YouMayAlsoLike.module.css';

// All pages data including unbuilt pages - moved outside component to avoid dependency issues
const allPages = [
    {
      id: 'cosy-stays',
      title: 'Cosy Stays',
      description: 'Discover our comfortable rooms with stunning views of Harlech Castle and the Welsh mountains.',
      image: '/website_images/rosie_room1.jpg',
      available: true
    },
    {
      id: 'welcoming-bar',
      title: 'Welcoming Bar',
      description: 'Relax in our friendly bar with local ales, spirits, and traditional Welsh hospitality.',
      image: '/website_images/bar_facing_bar.jpg',
      available: true
    },
    {
      id: 'tasty-bites',
      title: 'Tasty Bites',
      description: 'Enjoy delicious home-cooked meals made with fresh, local ingredients.',
      image: '/website_images/food_burger.jpg',
      available: true
    },
    {
      id: 'pawsome-pets',
      title: 'P-awesome Pets',
      description: 'Bring your four-legged friends! Learn about our dog-friendly facilities and local pet policies.',
      image: '/website_images/dog_friendly_pups.jpg',
      available: true
    },
    {
      id: 'private-events',
      title: 'Private Events',
      description: 'Make your special occasion unforgettable with our private event spaces. Whether it\'s a birthday celebration, anniversary, or business meeting, we\'ll help you create the perfect atmosphere.',
      image: '/website_images/private_events.jpg',
      available: true
    },
    {
      id: 'our-story',
      title: 'Our Story',
      description: 'Discover the rich history and heritage of The Queens Hotel. From its origins as a traditional Welsh inn to its transformation into a modern family-run establishment, every corner tells a story.',
      image: '/website_images/our_story.jpg',
      available: true
    },
    {
      id: 'local-area',
      title: 'Local Area',
      description: 'Explore historic Harlech Castle, beautiful beaches, and Snowdonia National Park. From medieval history to stunning coastal walks, there\'s something for everyone.',
      image: '/website_images/area_castle.jpg',
      available: true
    },
    {
      id: 'contact',
      title: 'Contact',
      description: 'Get in touch with us for bookings, enquiries, or any questions about your stay. Multiple ways to reach our friendly team.',
      image: '/website_images/external_front.jpg',
      available: true
    }
];

const YouMayAlsoLike = ({ currentPage, onNavigate }) => {
  const [suggestions, setSuggestions] = useState([]);

  // Function to get random suggestions with even distribution
  const getRandomSuggestions = useCallback(() => {
    // Filter out current page
    const availablePages = allPages.filter(page => page.id !== currentPage);
    
    // Shuffle array for randomness
    const shuffled = [...availablePages].sort(() => Math.random() - 0.5);
    
    // Return first 3 pages
    return shuffled.slice(0, 3);
  }, [currentPage]);

  useEffect(() => {
    setSuggestions(getRandomSuggestions());
  }, [currentPage, getRandomSuggestions]);

  const handlePageClick = (pageId, available) => {
    if (available && onNavigate) {
      onNavigate(pageId);
    }
  };

  return (
    <div className={styles['you-may-also-like']}>
      <div className={styles.container}>
        <h2 className={styles.title}>You may also like</h2>
        <div className={styles['suggestions-grid']}>
          {suggestions.map((page) => (
            <div 
              key={page.id} 
              className={`${styles['suggestion-card']} ${!page.available ? styles.unavailable : ''}`}
              onClick={() => handlePageClick(page.id, page.available)}
            >
              <div className={styles['image-container']}>
                <img 
                  src={page.image} 
                  alt={page.title}
                  className={styles['suggestion-image']}
                />
                {!page.available && (
                  <div className={styles['coming-soon-overlay']}>
                    <span>Coming Soon</span>
                  </div>
                )}
              </div>
              <div className={styles['suggestion-content']}>
                <h3 className={styles['suggestion-title']}>{page.title}</h3>
                <p className={styles['suggestion-description']}>{page.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default YouMayAlsoLike;